(function () {
  function init() {
    const popup = document.querySelector('[data-launch-popup]');
    const overlay = document.querySelector('[data-launch-popup-overlay]');
    const closeBtn = document.querySelector('[data-launch-popup-close]');
    const ctaBtn = popup.querySelector('.launch-popup__cta');
    if (!popup || !overlay) return;

    const storageKey = 'huella-andina-launch-popup-dismissed';
    const frequencyDays = parseFloat(popup.dataset.frequencyDays || '3');
    const delaySeconds = parseFloat(popup.dataset.delay || '2');

    if (frequencyDays > 0) {
      const dismissedAt = localStorage.getItem(storageKey);
      if (dismissedAt) {
        const elapsedDays = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
        if (elapsedDays < frequencyDays) return;
      }
    }

    function open() {
      overlay.classList.add('is-active');
      popup.classList.add('is-active');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('is-active');
      popup.classList.remove('is-active');
      document.documentElement.style.overflow = '';
      localStorage.setItem(storageKey, Date.now().toString());
    }

    setTimeout(open, delaySeconds * 1000);

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (ctaBtn) ctaBtn.addEventListener('click', function () {
      localStorage.setItem(storageKey, Date.now().toString());
    });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-active')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
